export default "/images/vendor/@coreui/icons/svg/flag/cif-vg.svg?3f651786366ef6239babe31ed3aa4557";